export const isUniframe = () =>
  (window as any)?.BybitUniFrame &&
  typeof (window as any)?.BybitUniFrame.ready === 'function';

// uniframe 已就绪
export const uniframeReady = () => {
  if (isUniframe()) return Promise.resolve();
  return new Promise((done) => {
    window.addEventListener('load', () => {
      if (isUniframe()) done(true);
    });
  });
};

export const showComplianceWall = (retCode: number, config: any) => {
  uniframeReady().then(() => {
    (window as any)?.BybitUniFrame.ready(({ complianceWall }) => {
      complianceWall.showModal(retCode, config);
    });
  });
};
